import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ButtonGroup,
} from 'reactstrap';
import classnames from 'classnames';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import CrmCustomerTable from '../components/CrmCustomerTable';
import CrmDataTable from '../components/CrmDataTable';
import CrmCampaignTable from '../components/CrmCampaignTable';

class CrmCampaignPage extends React.Component {
  _isMounted = true;
  comp = StorageService.getSession('selected_org');
  constructor(props) {
    super(props);
    this.state = {
      Role: this.comp.Role,
      redirect: false,
      isLoading: true,
      customerList: [],
      filteredList: [],
      searchKey: '',
      //   tabList: [{ name: 'Customer' }, { name: 'Data' }],
      activeTab: '1',
    };
  }

  componentDidMount() {}

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  detail = id => {
    console.log(`/crmcampaign/${id}`);
    this.props.history.push({
      pathname: `/crmcampaign/${id}`,
    });
  };

  render() {
    const { activeTab, Role } = this.state;
    return (
      <Page
        className="CrmCampaignPage"
        title="Campaign"
        breadcrumbs={[{ name: 'Campaign', active: true, path: '/crmcampaign' }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        {(Role === 'Superuser' || Role === 'Admin' || Role === 'Manager') && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card className="ps-card-display main">
                <CardBody>
                  <CrmCampaignTable {...this.props} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Page>
    );
  }
}

export default CrmCampaignPage;
